import z from "zod";

export const getAlertSchema = z.object({
	alertId: z.uuid(),
});

export type GetAlertSchema = z.infer<typeof getAlertSchema>;
